<div class="spending-limit-container">
  <!-- Основная строка с иконкой, текстом и toggle -->
  <div class="spending-limit-header">
    <app-item-icon icon="speedometer" appearance="blue"></app-item-icon>

    <h2 class="spending-limit-title">Установить лимит на расходные операции</h2>

    <ion-toggle
      mode="ios"
      [checked]="isEnabled"
      [disabled]="isDisabled"
      (ionChange)="onToggleChange($any($event))"
      data-testid="spending-limit-toggle"
    ></ion-toggle>
  </div>

  <!-- Дополнительные настройки (показываются только когда toggle включен) -->
  <div class="spending-limit-settings" *ngIf="isEnabled" data-testid="spending-limit-settings">
    <!-- Информация о лимите и остатке -->
    <!-- <div class="spending-limit-info" *ngIf="hasLimitRestInfo">
      <div class="info-row">
        <span class="info-label">Установленный лимит:</span>
        <span class="info-value">{{ limitAmount | amount }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Остаток лимита:</span>
        <span class="info-value info-value--accent">{{ limitRest | amount }}</span>
      </div>
    </div> -->

    <!-- Кнопка редактирования лимита -->
    <button
      class="spending-limit-edit-button"
      type="button"
      [disabled]="isDisabled"
      (click)="openLimitSettings()"
      data-testid="spending-limit-edit-button"
    >
      <span class="limit-amount-text">
        {{ isEnabled && limitAmount > 0 ? 'Лимит: ' + (limitAmount | amount) : 'Установить лимит' }}
      </span>
      <ion-icon icon="pencil-outline"></ion-icon>
    </button>

    <!-- Чекбокс для отображения остатка лимита -->
    <div class="spending-limit-checkbox-wrapper">
      <ion-checkbox
        mode="ios"
        [checked]="showRemainingLimit"
        [disabled]="isDisabled"
        (ionChange)="onShowRemainingChange($any($event))"
        data-testid="spending-limit-show-remaining-checkbox"
      ></ion-checkbox>

      <label
        class="spending-limit-checkbox-label"
        (click)="onCheckboxLabelClick()"
        data-testid="spending-limit-checkbox-label"
      >
        Показывать остаток месячного лимита вместо остатка средств
      </label>
    </div>
  </div>
</div>
